import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getConfigurations = async (appId: string, context?: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/global${
      context ? `/${context}` : ""
    }?appId=${appId}`
  );

  return data;
};

export const createConfiguration = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/global?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateConfiguration = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/global?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteConfiguration = async (configId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/global/${configId}`
  );

  return data;
};
